import React from "react";
import { Box, styled, Typography } from "@material-ui/core";

import { FlagIcon, FilledFlagIcon } from "../../../icons";
import { formatDate } from "../../../utils/formatDate";
import { DueStatus } from "../../../api/services";

const OverdueIcon = styled(FilledFlagIcon)(({ theme }) => ({
  width: 22,
  height: 22,
  fill: theme.palette.error.main,
}));

const NeardueIcon = styled(FlagIcon)(({ theme }) => ({
  width: 22,
  height: 22,
  fill: theme.palette.warning.main,
}));

const OkIcon = styled(FlagIcon)(({ theme }) => ({
  width: 22,
  height: 22,
  fill: theme.palette.text.secondary,
}));

export const TicketDueCell: React.FC<{
  dueDttm: string | null;
  dueStatus: DueStatus;
}> = ({ dueDttm, dueStatus }) => {
  return dueStatus === "NoDueDttm" ? (
    <Typography variant="body1" component="span">
      -
    </Typography>
  ) : (
    <Box display="flex" alignItems="center">
      {dueStatus === "Overdue" ? (
        <OverdueIcon />
      ) : dueStatus === "NearDue" ? (
        <NeardueIcon />
      ) : (
        <OkIcon />
      )}
      <Box ml={0.5}>
        <Typography variant="body1" component="span">
          {formatDate(dueDttm)}
        </Typography>
      </Box>
    </Box>
  );
};
